module.exports = __webpack_public_path__ + "img/accounting.26848dba.jpg";